import React, { FC, useState, KeyboardEvent } from 'react';
import Grid from '@mui/material/Grid';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface CustomAccordionProps {
  summary: string;
  detailComponent: React.ReactNode;
  defaultExpanded?: boolean;
  backgroundColor?: string;
}

const CustomAccordion: FC<CustomAccordionProps> = (props) => {
  let { summary, detailComponent, defaultExpanded = true, backgroundColor = '#d15a72' } = props;

  const [expanded, setExpanded] = useState<boolean>(defaultExpanded);

  const toggle = () => setExpanded((e) => !e);

  const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggle();
    }
  };

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        onClick={toggle}
        onKeyDown={onKeyDown}
        role="button"
        aria-expanded={expanded}
        tabIndex={0}
        style={{
          padding: '4px 15px',
          cursor: 'pointer',
          background: backgroundColor,
          userSelect: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {summary}
        <KeyboardArrowDownIcon
          style={{
            transition: 'transform 0.3s ease',
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </Grid>

      <Grid item xs={12} style={{ paddingLeft: 15, overflow: 'hidden' }}>
        <Collapse in={expanded} timeout="auto" mountOnEnter unmountOnExit>
          <div style={{ paddingTop: 8, paddingBottom: 8 }}>{detailComponent}</div>
        </Collapse>
      </Grid>
    </Grid>
  );
};

export default CustomAccordion;
